module.exports = __webpack_public_path__ + "img/add-departure.58975f7e.svg";